import {
    api
} from "@/api";
import actions from '@/store/actions';
import {
    isLogged,
    getUser,
    Logout as clearSessionLogout
} from "@/utils/user.utils";

let timeout = 0;
let isFirstRefresh = true;

export default class onLoad {
    /**
     * init App
     */
    initApp() {
        let loggedReqs = [];

        if (isLogged()) {
            actions.updateUser(getUser().user);
            loggedReqs = [
                api.getNotifications()
                .then((notifications) => {
                    actions.updateNotifications(notifications);
                    return notifications;
                })
            ]
            Promise.all([
                    api.getZP(),
                    api.GetUserRestrictions()
                ])
                .then(([{
                    points
                }, restrictions]) => {
                    actions.updateZP(points);
                    actions.updateUserRestrictions(restrictions);
                }).catch(({
                    status
                }) => {
                    if (status == 401) {
                        clearSessionLogout()
                    }
                })
        } else {
            Promise.all([
                    api.getAuthUser(),
                    api.GetUserRestrictions()
                ])
                .then(([_user, restrictions]) => {
                    actions.updateUserRestrictions(restrictions);
                })
        }
        const reqs = [
            // Get payments config
            api.getConfig().then(config => {
                actions.updateConfig(config);
                return config
            }),
            api.getTotalInGameOnline().then((data) => {
                actions.updateTotalInGameOnline(data)
                return data;
            }),
            ...loggedReqs,
        ];

        return Promise.all(reqs);
    }

    check() {
        let loggedReqs = [];
        if (isLogged()) {
            actions.updateUser(getUser().user);
            loggedReqs = [
                api.getNotifications()
                .then((notifications) => {
                    actions.updateNotifications(notifications);
                    return notifications;
                })
            ]
            Promise.all([
                    api.getZP(),
                    api.GetUserRestrictions()
                ])
                .then(([{
                    points
                }, restrictions]) => {
                    actions.updateZP(points);
                    actions.updateUserRestrictions(restrictions);
                }).catch(({
                    status
                }) => {
                    if (status == 401) {
                        clearSessionLogout()
                    }
                })
        }
        const reqs = [
            api.getTotalInGameOnline().then((data) => {
                actions.updateTotalInGameOnline(data)
                return data;
            }),
            ...loggedReqs
        ];

        return Promise.all(reqs);
    }

    async refresh() {
        clearTimeout(timeout)
        timeout = setTimeout(async() => {
            await this.check()
            isFirstRefresh = false
            this.refresh();
        }, isFirstRefresh ? 1500 : 60000)
    }
}
